/**
 * user-preferences.ts — per-user UI prefs API.
 *
 * Closes the legacy ColorPalettesController + ReportsUserPreference
 * parity from Pat's gap analysis. Today we host chart palette + theme;
 * report prefs land in the same blob later.
 */

import { apiGet, apiPatch, apiPut, apiDelete } from '@/api/client';

export interface UserPreferences {
  chartColors?: string[];
  theme?: 'light' | 'dark' | 'system';
  tablesDense?: boolean;
  reportPrefs?: Record<string, unknown>;
  [key: string]: unknown;
}

export const userPreferencesApi = {
  get: (userId: number) => apiGet<UserPreferences>(`/users/${userId}/preferences`),
  /** Replace the entire blob. */
  put: (userId: number, prefs: UserPreferences) =>
    apiPut<UserPreferences>(`/users/${userId}/preferences`, prefs),
  /** Merge a partial — server uses jsonb || to keep unsent keys. */
  patch: (userId: number, partial: Partial<UserPreferences>) =>
    apiPatch<UserPreferences>(`/users/${userId}/preferences`, partial),
  /** Remove a single key. */
  deleteKey: (userId: number, key: string) =>
    apiDelete(`/users/${userId}/preferences/${encodeURIComponent(key)}`),
};
